import { apiClient } from "../config";

async function deleteDataPortal(id: any){
  const res = await apiClient.delete(`/admin/data-portals/${id}`);
  return res.data;
}

export default deleteDataPortal;
